<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-button type="primary" @click="addcar">还车申请</a-button>
    </div>
    <div class="content_main_top">
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.subsidyCode"
        allowClear
        placeholder="审批编号"
        @keyup.enter.native="serch_get_lis"
      />
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.createByName"
        allowClear
        placeholder="申请人"
        @keyup.enter.native="serch_get_lis"
      />
       <a-select
        show-search
        allowClear
        placeholder="所属公司"
        class="margin_self"
        @change="handlecompany"
        v-model="serchInfo.belongCompanyId"
        @keyup.enter.native="serch_get_lis"
        style="width: 160px"
      >
        <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
          {{ item.title }}
        </a-select-option>
      </a-select>
       <a-tree-select
        allowClear
        :treeData="deptTree2"
        v-model="serchInfo.belongDeptId"
        :disabled="!serchInfo.belongCompanyId"
        placeholder="所属部门"
        @keyup.enter.native="serch_get_lis"
        class="margin_self"
        style="width: 170px"
        treeDefaultExpandAll
      >
      </a-tree-select>
      <!-- <a-tree-select
        class="a_select_self margin_self"
        allowClear
        :treeData="deptTree"
        placeholder="所属部门"
        v-model="serchInfo.belongDeptId"
        treeDefaultExpandAll
        @keyup.enter.native="serch_get_lis"
      ></a-tree-select> -->
      <a-range-picker
        valueFormat="YYYY-MM-DD"
        style="margin-right: 10px; width: 240px"
        allowClear
        :value="dates"
        @change="onChange"
        @keyup.enter.native="serch_get_lis"
        :placeholder="['申请开始时间', '申请结束时间']"
      />
      <a-select
        show-search
        allowClear
        class="a_select_self margin_self"
        v-model="serchInfo.carTypes"
        placeholder="车辆属性"
        @keyup.enter.native="serch_get_lis"
      >
        <a-select-option :key="index" v-for="(item, index) in carMap2" :value="index">
          {{ item }}
        </a-select-option>
      </a-select>
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.plateNumber"
        allowClear
        placeholder="牌照号"
        @keyup.enter.native="serch_get_lis"
      />
      <a-button type="primary" @click="serch_get_lis"> 查询 </a-button>
      <a-button type="primary" ghost @click="result"> 重置 </a-button>
      <a-button type="primary" @click="download"> 导出 </a-button>

    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table
        :data-source="lis"
        bordered
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :scroll="{ x: 2000, y: scroll_y, scrollToFirstRowOnChange: true }"
      >
        <a-table-column key="subsidyCode" title="审批编号" ellipsis="true" data-index="subsidyCode" width="220px" />
        <a-table-column key="title" title="标题" ellipsis="true" data-index="title" />
        <a-table-column key="createByName" title="申请人" ellipsis="true" data-index="createByName" />
        <a-table-column key="companyUseName" title="所属公司" ellipsis="true" data-index="companyUseName" />
        <a-table-column key="deptUseName" title="所属部门" ellipsis="true" data-index="deptUseName" />
        <a-table-column key="createTime" title="申请时间" ellipsis="true" data-index="createTime" />
        <a-table-column key="carTypes" title="车辆属性" ellipsis="true" data-index="carTypes">
          <template scope="text,record">
            {{ carMap2[record.carTypes] }}
          </template>
        </a-table-column>
        <a-table-column key="plateNumber" title="牌照号" ellipsis="true" data-index="plateNumber" />
        <a-table-column key="useCarDate" title="实际用车日期" ellipsis="true" data-index="useCarDate" />
        <a-table-column key="stillCarDate" title="实际还车日期" ellipsis="true" data-index="stillCarDate" />
        <a-table-column key="travelMileage" title="行驶里程数" ellipsis="true" data-index="travelMileage" />
        <a-table-column key="applyMileage" title="申请积分里程数" ellipsis="true" data-index="applyMileage" />
        <a-table-column key="goMileage" title="出车前里程" ellipsis="true" data-index="goMileage" />
        <a-table-column key="backMileage" title="还车时里程" ellipsis="true" data-index="backMileage" />
        <a-table-column key="money" title="本次出行加油金额" ellipsis="true" data-index="money" />
        <a-table-column title="操作" width="150px">
          <template scope="text,record">
            <a @click="show_details(record)">详情</a>
            <a-divider type="vertical" />
            <a @click="handFlow(record)">历史</a>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      title="还车申请"
      :visible="carvisible"
      @cancel="carvisible = false"
      :confirm-loading="confirmLoading"
      width="70%"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkCar"> 提交 </a-button>
        <a-button key="back" @click="carvisible = false"> 取消 </a-button>
      </template>
      <a-form-model :model="form" :rules="rules" ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
        <a-row>
          <a-form-model-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <ccChange :data="ccC" @targetKeys="getdata" v-if="isRouterAlive" />
          </a-form-model-item>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="关联审批单"
              :rules="{
                required: true,
              }"
            >
              <a-button type="primary" @click="showAuditCode"> 关联 </a-button>
              <!-- <a-input allowClear v-model="form.auditCode" @click="showAuditCode" :disabled="!form.reimburseType" placeholder="请输入"></a-input> -->
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <div>
                <span v-for="(item, index) in auditCodeData" :key="index" class="auditItem">
                  <span @click="handelAudit(index)">{{ item.processName }}</span>
                  <a-icon class="close_icon2" @click="delete_auditCode(index)" type="close" />
                </span>
                <span v-for="(item, index) in auditCodeData2" :key="index" class="auditItem">
                  <span @click="handelAudit2(index)">{{ item.title }}</span>
                  <a-icon class="close_icon2" @click="delete_auditCode2(index)" type="close" />
                </span>
                <span v-for="(item, index) in auditCodeData3" :key="index" class="auditItem">
                  <span @click="handelAudit3(index)">{{ item.title }}</span>
                  <a-icon class="close_icon2" @click="delete_auditCode3(index)" type="close" />
                </span>
                <span v-for="(item, index) in auditCodeData4" :key="index" class="auditItem">
                  <span @click="handelAudit4(index)">{{ item.title }}</span>
                  <a-icon class="close_icon2" @click="delete_auditCode4(index)" type="close" />
                </span>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="所属部门"
              :rules="{
                required: true,
              }"
            >
              <a-tree-select
                allowClear
                :treeData="deptTree"
                @change="ccsd"
                placeholder="请输入"
                v-model="form.belongDeptId"
                treeDefaultExpandAll
              >
              </a-tree-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="车辆属性"
              :rules="{
                required: true,
              }"
            >
              <a-select
                show-search
                allowClear
                class="margin_self"
                @change="ccsds"
                v-model="form.carTypes"
                placeholder="请选择"
              >
                <a-select-option :key="index" v-for="(item, index) in carMap2" :value="index">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="牌照号"
              :rules="{
                required: true,
              }"
            >
              <a-select
                v-model="form.plateNumber"
                @change="changePlateNum"
                disabled
                allowClear
                show-search
                placeholder="请选择"
                v-if="form.carTypes == '0'"
              >
                <a-select-option :key="index" v-for="(item, index) in lisCarLis" :value="item.plateNumber">
                  {{ item.plateNumber }}
                </a-select-option>
              </a-select>
              <a-input v-model="form.plateNumber" @input="ccsd" v-else placeholder="请输入牌照号"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <!-- <a-col :span="8">
						<a-form-model-item label="实际用车时间" prop="useCarDate">
							<a-date-picker v-model="form.useCarDate" @change="useCarDateChange" show-time :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm"
							 allowClear style="width: 267px" placeholder="请选择" />
						</a-form-model-item>
					</a-col> -->
          <a-col :span="8">
            <a-form-model-item label="实际用车日期" prop="data" style="width: 100%">
              <a-date-picker
                allowClear
                v-model="form.data"
                placeholder="选择日期"
                format="YYYY-MM-DD"
                @change="onChangeData"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="实际用车时间" prop="time" style="width: 100%">
              <a-time-picker allowClear v-model="form.time" format="HH:mm" valueFormat="HH:mm" @change="onChangeTime" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="最新里程数(km)" prop="latestMileage">
              <a-input v-model="form.latestMileage" disabled placeholder="请输入数字"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="出车前里程(km)"
              :rules="{
                required: true,
              }"
            >
              <a-input v-model="form.goMileage" type="number" @input="changtravel" placeholder="请输入数字"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="还车时里程(km)" prop="backMileage">
              <a-input v-model="form.backMileage" type="number" @input="changtravel" placeholder="请输入数字"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="行驶里程数(km)">
              <a-input disabled v-model="form.travelMileage" placeholder="请输入数字"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="申请积分里程(km)" prop="applyMileage">
              <a-input v-model="form.applyMileage" type="number" placeholder="请输入与工作相关的实际里程数"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="项目数">
              <a-input v-model="form.projectNum" type="number" placeholder="请输入项目数"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="目的地" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-textarea
                :auto-size="{ minRows: 1, maxRows: 3 }"
                v-model="form.destination"
                allowClear
                placeholder="具体到区县"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-textarea
                :auto-size="{ minRows: 1, maxRows: 3 }"
                v-model="form.remark2"
                allowClear
                placeholder="请输入"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              label="出车前后里程"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 21 }"
              :rules="{
                required: true,
              }"
            >
              <uploadImgJavam @add="mImgadd" @reduce="mImgreduce" :data="mileageImgs" v-if="isRouterAlive" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              label="出车后车内卫生"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 21 }"
              :rules="{
                required: true,
              }"
            >
              <uploadImgJavah @add="hImgadd" @reduce="hImgreduce" :data="hygieneImgs" v-if="isRouterAlive" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="车辆情况">
              <a-select show-search allowClear class="margin_self" v-model="form.vehicleCondition" placeholder="请选择">
                <a-select-option :key="index" v-for="(item, index) in carStatus" :value="index">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="16">
            <a-form-model-item
              label="车辆备注"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 21 }"
              v-if="form.vehicleCondition == 2"
            >
              <a-input v-model="form.remark" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <div class="pay_top">
            <span class="form_title">加油详情</span>
          </div>
        </a-row>
        <a-row v-for="(domain, index) in form.oils" :key="index">
          <a-col :span="8">
            <a-form-model-item label="加油里程(km)">
              <a-input v-model="domain.fuelMileage" type="number" placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="加油金额(元)">
              <a-input v-model="domain.fuelMoney" type="number" @blur="changeMoney" placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <div class="closeIoc">
              <a-icon class="delico" @click="delItemOils(index)" v-if="form.oils.length > 1" type="close" />
            </div>
          </a-col>
        </a-row>
        <a-row>
          <div class="rowBox">
            <a-button type="primary" @click="addPush"> 增加加油详情 </a-button>
          </div>
        </a-row>

        <a-row>
          <a-col :span="8">
            <a-form-model-item label="本次出行加油金额">
              <a-input disabled v-model="form.money" placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="金额大写">
              <a-input disabled v-model="form.capitalizeMoney" placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <div class="last_title">
            <div style="font-size: 18px">流程使用说明：</div>
            1、出车前和出车后必须拍照记录当时车辆里程。如果加油，请将加油发票或小票拍照存档（办油卡的拍小票）。<br />
            2、一车一补贴，还车时每辆车需要单独提还车补贴申请<br />
            3、还车时，需要关联用车申请，系统将自动获取车辆明细信息
          </div>
        </a-row>
      </a-form-model>
    </a-modal>
    <selectAuditCode2
      ref="selectAuditCode2"
      :data="{ auditCodeData, auditCodeData2, auditCodeData3, auditCodeData4 }"
      @applyData="getAppCode"
      @applyData2="getAppCode2"
      @applyData3="getAppCode3"
      @applyData4="getAppCode4"
      @applyAll="getApplyAll"
      v-if="isRouterAlive"
    />
    <proc-flow-modal ref="modalflow" @ok="handleOk" />
    <business-modal ref="modal" @ok="handleOk" />
    <leave-modal ref="leavemodal" @ok="handleOk" :audit="false" />
    <purchase-modal ref="purchasemodal" @ok="handleOk" :audit="false" />
    <scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
    <receive-modal ref="receiveModal" @ok="handleOk" :audit="false" />
    <operation-modal ref="operationmodal" @ok="handleOk" :audit="false" />
    <service-modal ref="servicemodal" @ok="handleOk" :audit="false" />
    <reimbursement-modal ref="reimbursementmodal" @ok="handleOk" :audit="false" />
    <!-- 详情 -->
    <contractModal ref="contractmodal" @ok="handleOk" :audit="false" />
    <sealModal ref="sealmodal" @ok="handleOk" :audit="false" />
    <currencyModal ref="currencymodal" @ok="handleOk" :audit="false" />
    <returnModal ref="returnmodal" @ok="handleOk" :audit="false" />
    <car-modal ref="carmodal" @ok="handleOk" :audit="false" />
    <returncar-modal ref="returncarmodal" @ok="handleOk" :audit="false" />
    <payMentModal ref="paymentmodal" @ok="handleOk" :audit="false" />
    <salaryModal ref="salarymodal" @ok="handleOk" :audit="false" />
    <adjustmentModal ref="adjustmentmodal" @ok="handleOk" :audit="false" />
    <charge-modal ref="chargemodal" @ok="handleOk" :audit="false" />
    <other-modal ref="othermodal" @ok="handleOk" :audit="false" />
    <feedback-modal ref="feedbackmodal" @ok="handleOk" :audit="false" />
  </div>
</template>
<script>
import { limitCompany } from '@/utils/limitCompany'
import { subsidyApply } from '@/api/financial'
import { downLoadXlxs2 } from '@/utils/index'
import debounce from 'lodash/debounce'
import { getDeptListEnable2 } from '@/api/system'
import { modalMap, getCarApply } from '@/api/activiti'
import {
  biz_car_subsidy_apply,
  biz_car_subsidy_apply_save,
  biz_car_subsidy_apply_code,
  listAllPage,
} from '@/api/administrative'
import // get_dept_tree,
// get_dept_tree2
'@/api/assetmenag'
import selectAuditCode2 from '@/components/module/selectAuditCode2.vue'
import ccChange from '@/components/module/ccChange'
import ProcFlowModal from '../activiti/modules/ProcFlowModal.vue' //历史
import uploadImgJava from '@/components/module/uploadImgJava.vue'
import uploadImgJavam from '@/components/module/uploadImgJavam.vue'
import uploadImgJavah from '@/components/module/uploadImgJavah.vue'
import uploadImgJavan from '@/components/module/uploadImgJavan.vue'

import payMentModal from '@/views/activiti/modules/payMentModal.vue'
import BusinessModal from '../activiti/modules/BusinessModal.vue'
import LeaveModal from '../activiti/modules/LeaveModal.vue'
import PurchaseModal from '../activiti/modules/PurchaseModal.vue'
import ScrapModal from '../activiti/modules/ScrapModal.vue'
import receiveModal from '../activiti/modules/receiveModal.vue'
import OperationModal from '../activiti/modules/OperationModal.vue'
import ServiceModal from '../activiti/modules/ServiceModal.vue'
import ReimbursementModal from '../activiti/modules/ReimbursementModal.vue'
import contractModal from '@/views/activiti/modules/contractModal.vue'
import sealModal from '@/views/activiti/modules/sealModal.vue'
import currencyModal from '@/views/activiti/modules/currencyModal.vue'
import returnModal from '@/views/activiti/modules/returnModal.vue'
import carModal from '@/views/activiti/modules/carModal.vue'
import returncarModal from '@/views/activiti/modules/returncarModal.vue'
import salaryModal from '@/views/activiti/modules/salaryModal.vue'
import adjustmentModal from '@/views/activiti/modules/adjustmentModal.vue'
import chargeModal from '@/views/activiti/modules/chargeModal.vue'
import otherModal from '@/views/activiti/modules/otherModal.vue'
import feedbackModal from '@/views/activiti/modules/feedbackModal.vue'
export default {
  components: {
    selectAuditCode2,
    ccChange,
    ProcFlowModal,
    uploadImgJava,
    uploadImgJavam,
    uploadImgJavah,
    uploadImgJavan,

    payMentModal,
    BusinessModal,
    LeaveModal,
    PurchaseModal,
    ScrapModal,
    receiveModal,
    OperationModal,
    ServiceModal,
    ReimbursementModal,
    contractModal,
    sealModal,
    currencyModal,
    returnModal,
    carModal,
    returncarModal,
    salaryModal,
    adjustmentModal,
    chargeModal,
    otherModal,
    feedbackModal,
  },
  data() {
    return {
      mImg: 0,
      hImg: 0,
      nImg: 0,
      labelCol3: {
        span: 2,
      },
      wrapperCol3: {
        span: 22,
      },
      dates: [],
      isRouterAlive: true,
      changecar: false,
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      deptTree: [],
      form: {
        oils: [
          {
            fuelMileage: '',
            fuelMoney: '',
          },
        ],
      },
      rules: {
        // useCarDate: [{
        // 	required: true,
        // 	message: '请选择实际用车日期',
        // 	trigger: 'change',
        // }, ],
        backMileage: [
          {
            required: true,
            message: '请输入还车时里程(km)',
            trigger: 'change',
          },
        ],
        data: [
          {
            required: true,
            message: '请选择实际用车日期',
            trigger: 'change',
          },
        ],
        time: [
          {
            required: true,
            message: '请选择实际用车时间',
            trigger: 'change',
          },
        ],
        applyMileage: [
          {
            required: true,
            message: '请输入申请积分里程(km)',
            trigger: 'change',
          },
        ],
        fuelMileage: [
          {
            required: true,
            message: '请输入加油里程(km)',
            trigger: 'change',
          },
        ],
        fuelMoney: [
          {
            required: true,
            message: '请输入加油金额',
            trigger: 'change',
          },
        ],
      },
      serchInfo: {
        subsidyCode: '',
        createByName: '',
        createTime1: '',
        createTime2: '',
        belongDeptId: undefined,
        plateNumber: '',
        belongCompanyId: undefined,
        carTypes: undefined,
      },
      auditCodeData: [],
      auditCodeData2: [],
      auditCodeData3: [],
      auditCodeData4: [],
      scroll_y: 150,
      loading: false,
      mileageImgs: {
        code: '',
        type: 'mileage-imgs',
      },
      hygieneImgs: {
        code: '',
        type: 'hygiene-imgs',
      },
      lis: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      is_details: false,
      formrow: {},
      carvisible: false,
      ccC: '',
      lisCarLis: [], //所有公车车牌
      onlyId: '',
      timeData: '00:00',
      companylist: [],
      deptTree2: [],
    }
  },
  created() {
      limitCompany().then((res) => {
        res.forEach((item) => {
          if (item.deptId) {
            this.companylist.push(item)
          }
        })
      })
},
  mounted() {
    this.get_list()
 
    // get_dept_tree().then((res) => {
    // 	this.companylist = res.data.dept_lis
    // 	this.companylist.unshift({
    // 		dept_id: 0,
    // 		dept_name: '所有公司',
    // 		child_lis: [],
    // 	})
    // })
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 120
      }, 1000)
    })
    // get_dept_tree2().then((res) => {
    // 	this.companylist2 = res.data.dept_lis
    // })
    getDeptListEnable2().then((res) => {
      const data = res.rows
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree2(data, this.deptTree, this.$store.getters.userInfo.companyId)
      }
    })
    this.get_all_car_lis()
  },
  methods: {
     //切换公司
	  handlecompany(e) {
      this.serchInfo.deptId = undefined
		for (let i = 0; i < this.companylist.length; i++) {
			if(this.serchInfo.belongCompanyId == this.companylist[i].deptId){
				this.deptTree2 = this.companylist[i].children
			}
		}
    },
    download() {
      var _this = this
      this.$confirm({
        title: '是否需要重新选择需要导出的申请日期范围？',
        icon: ' ',
        okText: '是', 
        cancelText: '否', 
        centered:true,//页面居中位置
        onOk() {
          _this.$message.warning('请重新选择日期！')
        },
        onCancel() {
              downLoadXlxs2(process.env.VUE_APP_API_BASE_URL + '/act/biz_car_subsidy_apply/export',
                {
                  subsidyCode: _this.serchInfo.subsidyCode,
                  createByName: _this.serchInfo.createByName,
                  belongDeptId: _this.serchInfo.belongDeptId,
                  belongCompanyId: _this.serchInfo.belongCompanyId,
                  createTime1: _this.serchInfo.createTime1,
                  createTime2: _this.serchInfo.createTime2,
                  carTypes: _this.serchInfo.carTypes,
                  plateNumber: _this.serchInfo.plateNumber
                })
        },
        class: 'test',
      })
      // get_list2_xlsx
    
    },
    onChangeData(value, dateString) {
      this.form.data = dateString
      // let data = this.form.data + " " + this.timeData + ':00'
      this.timeData = this.form.data + ' ' + this.form.time + ':00'
      // this.form.useCarDate = this.form.data + " " + this.form.time + ':00'
      // let useTime = new Date(data)
      // console.log(useTime, 'useTime================')
      // this.form.useCarDate = useTime.getTime()

      console.log(dateString, 'this.data, this.datathis.datathis.datathis.datathis.data')
      console.log(this.timeData, 'timeData,')
    },
    onChangeTime(value) {
      console.log(value, 'value=================')
      this.form.time = value
      this.timeData = this.form.data + ' ' + this.form.time + ':00'
      // const data = this.form.data + " " + this.timeData + ':00'
      // const useTime = new Date(data)
      // console.log(useTime, 'useTime')
      // this.form.useCarDate = useTime.getTime()
      console.log(this.form.time, 'this.form.time ')
      console.log(this.timeData, 'this.timeData ')
    },
    // useCarDateChange(value, dateString) {
    // 	this.form.useCarDate = dateString
    // 	console.log(dateString, 'this.form.dateStringdateStringdateStringdateStringdateStringdateStringdateString ')
    // },
    result() {
      this.dates = []
      this.serchInfo = {}
    },
    mImgadd() {
      this.mImg++
    },
    mImgreduce() {
      this.mImg--
    },
    hImgadd() {
      this.hImg++
    },
    hImgreduce() {
      this.hImg--
    },
    nImgadd() {
      this.nImg++
    },
    nImgreduce() {
      this.nImg--
    },
    //获取公车车牌号
    get_all_car_lis() {
      listAllPage({
        pageNum: 1,
        pageSize: 999,
      }).then((res) => {
        this.lisCarLis = res.rows
      })
    },
    ccsd() {
      this.$forceUpdate()
    },
    ccsds() {
      this.form.plateNumber = undefined
      this.$forceUpdate()
    },
    //车牌号改变
    changePlateNum($event) {
      this.lisCarLis.forEach((item) => {
        if (item.plateNumber == $event) {
          this.form.latestMileage = item.latestMileage ? item.latestMileage : 0
          this.form.goMileage = item.latestMileage ? item.latestMileage : 0
          this.form.goMileage = this.form.latestMileage
          this.$forceUpdate()
        }
      })
    },
    //添加加油详情
    addPush() {
      this.form.oils.push({
        fuelMileage: '',
        fuelMoney: '',
        key: Date.now(),
      })
      this.$forceUpdate()
    },
    //删除
    delItemOils(idx) {
      this.form.oils.splice(idx, 1)
      this.$forceUpdate()
    },
    handelAudit(index) {
      var record = this.auditCodeData[index]
      const modal = modalMap[record.processDefKey]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: record.businessKey,
      })
    },
    handelAudit2(index) {
      var record = this.auditCodeData2[index]
      const modal = modalMap[record.procDefKey]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: record.businessKey,
      })
    },
    handelAudit3(index) {
      var record = this.auditCodeData3[index]
      const modal = modalMap[record.procDefKey]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: record.id,
      })
    },
    handelAudit4(index) {
      var record = this.auditCodeData4[index]
      const modal = modalMap[record.procDefKey]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: record.businessKey,
      })
    },
    delete_auditCode(index) {
      this.auditCodeData.splice(index, 1)
      console.log(this.auditCodeData)
    },
    delete_auditCode2(index) {
      this.auditCodeData2.splice(index, 1)
      console.log(this.auditCodeData)
    },
    delete_auditCode3(index) {
      this.auditCodeData3.splice(index, 1)
      console.log(this.auditCodeData)
    },
    delete_auditCode4(index) {
      this.auditCodeData4.splice(index, 1)
      console.log(this.auditCodeData)
    },
    //获取code
    getAppCode(data) {
      this.auditCodeData = data
    },
    getAppCode2(data) {
      this.auditCodeData2 = data
    },
    getAppCode3(data) {
      this.auditCodeData3 = data
    },
    getAppCode4(data) {
      this.auditCodeData4 = data
    },
    getApplyAll(data) {
      console.log(data, 'data=========================')
      if (data.length > 1) {
        this.auditCodeData = []
        this.auditCodeData2 = []
        this.auditCodeData3 = []
        this.auditCodeData4 = []
        this.$message.error('只可关联一条')
      } else {
        this.$message.success('关联成功')
        if (data[0].businessKey) {
          this.onlyId = data[0].businessKey
        } else {
          this.onlyId = data[0].id
        }
        getCarApply(this.onlyId).then((res) => {
          console.log(this.onlyId, 'data[0].id=======================')
          this.form.plateNumber = res.data.plateNumber
          this.form.latestMileage = res.data.latestMileage ? res.data.latestMileage : 0
          this.form.belongDeptId = res.data.deptUseId
          this.form.carTypes = res.data.carTypes
          this.form.destination = res.data.prefecture
          this.form.goMileage = this.form.latestMileage
          this.$forceUpdate()
        })
      }
    },
    showAuditCode() {
      this.$refs.selectAuditCode2.show(this.form.relationCode)
    },
    changeMoney() {
      var num = 0
      this.form.oils.forEach((item) => {
        num += item.fuelMoney ? Number(item.fuelMoney) : 0
      })
      this.form.money = num
      this.form.capitalizeMoney = this.convertCurrency(this.form.money)
      this.$forceUpdate()
    },
    changtravel() {
      this.form.travelMileage = ''
      this.ccsd()
      var back = this.form.backMileage
      var go = this.form.goMileage
      if (back !== '' && go !== '') {
        this.form.travelMileage = back - go
        this.form.travelMileage = this.form.travelMileage.toFixed(2)
      }
    },
    handFlow(row) {
      var obj = {
        procInstId: row.procInstId,
        procDefKey: row.procDefKey,
      }
      this.$refs.modalflow.show(obj)
    },
    onChange(date, dateString) {
      this.dates = date
      this.serchInfo.createTime1 = date[0]
      this.serchInfo.createTime2 = date[1]
    },
    add_detail() {
      this.form.bizCarInfos.push({
        carUser: '',
        peer: '',
        carReason: '',
        prefecture: '',
      })
    },
    //删除明细
    close_detail(index) {
      this.form.bizCarInfos.splice(index, 1)
    },
    getdata(data) {
      this.form.cc = data
    },
    handleOkCar: debounce(
      function () {
        this.$refs.ruleForm.validate((valid) => {
          if (
            this.auditCodeData.length == 0 &&
            this.auditCodeData2.length == 0 &&
            this.auditCodeData3.length == 0 &&
            this.auditCodeData4.length == 0
          ) {
            this.$message.error('请先关联审批单')
            return
          }
          if (this.mImg == 0) {
            this.$message.error('请上传出车前后里程照片')
            return
          }
          if (this.hImg == 0) {
            this.$message.error('请上传出车后车内外卫生照片')
            return
          }
          if (valid) {
            Object.assign(this.form, {
              useCarDate: this.timeData,
            })
            this.form['associateApply'] = []
            this.auditCodeData.forEach((item) => {
              this.form['associateApply'].push({
                associateTitle: item.processName,
                associateTypes: item.processDefKey,
                associateApply: item.businessKey,
                applyCode: item.applyCode,
              })
            })
            this.auditCodeData2.forEach((item) => {
              console.log(item)
              this.form['associateApply'].push({
                associateTitle: item.title,
                associateTypes: item.procDefKey,
                associateApply: item.businessKey,
                applyCode: item.applyCode,
              })
            })
            this.auditCodeData3.forEach((item) => {
              console.log(item)
              this.form['associateApply'].push({
                associateTitle: item.title,
                associateTypes: item.procDefKey,
                associateApply: item.id,
                applyCode: item.applyCode,
              })
            })
            this.auditCodeData4.forEach((item) => {
              console.log(item)
              this.form['associateApply'].push({
                associateTitle: item.title,
                associateTypes: item.procDefKey,
                associateApply: item.businessKey,
                applyCode: item.applyCode,
              })
            })
            this.form.belongCompanyId = this.$store.getters.userInfo.companyId
            this.form.cc = this.form.cc.length ? this.form.cc.join(',') : ''
            console.log(2234)
            biz_car_subsidy_apply_save(this.form).then((res) => {
              this.carvisible = false
              if (res.code == 200) {
                this.$message.success('添加成功')
                this.get_list()
              } else {
                this.$message.error(res.msg)
                return
              }
            })
          }
        })
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    ),
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    addcar() {
      this.auditCodeData = []
      this.auditCodeData2 = []
      this.auditCodeData3 = []
      this.auditCodeData4 = []
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
      this.carvisible = true
      this.form = {}
      this.form['oils'] = [
        {
          fuelMileage: '',
          fuelMoney: '',
          key: Date.now(),
        },
      ]
      biz_car_subsidy_apply_code().then((res) => {
        this.form.subsidyCode = res.data
        this.mileageImgs.code = res.data
        this.hygieneImgs.code = res.data
      })
    },
    //切换公司
    // handlecompany(value) {
    // 	this.deptlist = []
    // 	this.serchInfo.deptId = undefined
    // 	this.companylist.forEach((item) => {
    // 		if (item.dept_id == this.serchInfo.companyId) {
    // 			this.deptlist = item.child_lis
    // 		}
    // 	})
    // },
    //获取列表
    get_list() {
      biz_car_subsidy_apply({
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        createTime1: this.serchInfo.createTime1,
        createTime2: this.serchInfo.createTime2,
        createByName: this.serchInfo.createByName,
        subsidyCode: this.serchInfo.subsidyCode,
        belongDeptId: this.serchInfo.belongDeptId,
        belongCompanyId: this.serchInfo.belongCompanyId,
        plateNumber: this.serchInfo.plateNumber,
        carTypes: this.serchInfo.carTypes,
      }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          var lis = res.rows
          this.lis = res.rows
          const pagination = { ...this.pagination }
          pagination.total = res.total
          this.pagination = pagination
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    //重置
    reset() {
      this.serchInfo = {
        purchaseCode: '',
        createBy: '',
        status: undefined,
        buStatus: undefined,
        company_id: undefined,
        deptId: undefined,
        createTimelist: [],
      }
    },
    //搜索
    serch_get_lis() {
      this.loading = true
      this.pagination.current = 1
      this.get_list()
    },
    //改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loading = true
      this.get_list()
    },
    // 详情
    show_details(record) {
    //   this.$refs.returncarmodal.show({
    //     businessKey: record.buId,
    //   })
      this.$refs.returncarmodal.show({
        businessKey: record.buId,
        procInstId: record.procInstId,
        procDefKey: 'carSubsidyApply',
         recordNumber: 1
      })
    },
  },
}
</script>
<style scoped lang='less'>
.ant-table td {
  white-space: nowrap;
}

.form_title {
  margin-left: 15px;
  margin-bottom: 15px;
  font-size: 17px;
  color: #999;
}

.pay_top {
  width: 100%;
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close_icon {
  font-size: 20px;
  color: red;
  cursor: pointer;
}

.btn_last {
  width: 100%;
  text-align: center;
}

.last_title {
  margin-top: 20px;
  width: 100%;
  padding: 20px;
  background-color: #f8f8f7;
  color: #b6b6b6;
}

.close_icon2 {
  font-size: 14px;
  color: red;
  cursor: pointer;
}

.rowBox {
  width: 100%;
  float: left;
  padding-left: 160px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.icoSize {
  font-size: 24px;
  cursor: pointer;
}

.closeIoc {
  height: 35px;
  width: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.delico {
  cursor: pointer;
  font-size: 22px;
  color: red;
}
</style>
